import * as React from 'react';
import { getComposeEvent, getOriginalEvent } from 'owa-calendar-compose-store-manager';
import { LocationFreeBusyBadge } from 'owa-calendar-meeting-forms-common-view';
import { isFeatureEnabled } from 'owa-feature-flags';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isOriginalTime } from 'owa-calendar-event-capabilities';

export function renderLocationFBBadge(emailAddress: string, formId: string): JSX.Element {
    const event = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);

    const showFreeBusyStatus =
        !isOriginalTime(originalEvent, event) &&
        !isConsumer() &&
        (isFeatureEnabled('cal-mf-roomBookingPolicy') || !event.Recurrence);

    return showFreeBusyStatus ? (
        <LocationFreeBusyBadge event={event} emailAddress={emailAddress} />
    ) : null;
}
